import { useRef } from "react";
import toast from "react-hot-toast";

const useToastMessage = () => {
  const toastIdRef = useRef(null);

  const dismissOldToast = () => {
    if (toastIdRef.current) {
      toast.dismiss(toastIdRef.current);
    }
  };

  const showToast = (
    message,
    borderColor = "#1BA56F",
    fontWeight = "700",
    backgroundColor = "#fff"
  ) => {
    dismissOldToast();
    toastIdRef.current = toast(message, {
      duration: 3000,
      style: {
        color: borderColor, // text color same as border color
        border: `1px solid ${borderColor}`,
        fontWeight,
        background: backgroundColor,
        boxShadow: "none",
        borderRadius: "8px",
      },
    });
  };

  const showSuccessToast = (message = "Operation successful") => {
    showToast(message, "#1BA56F");
  };

  const showErrorToast = (message = "Something went wrong") => {
    showToast(message, "#D8000C");
  };

  return {
    showToast,
    showSuccessToast,
    showErrorToast,
  };
};

export default useToastMessage;
